export const uploadInjectionKey = Symbol('upload');
